/// <reference types="vite/client" />
// axiosSetup3.ts
import axiosOriginal, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '../store/useAuthStore3';

// Расширяем тип конфига, чтобы TS не ругался на поле _retry
interface CustomRequestConfig extends InternalAxiosRequestConfig {
  _retry?: boolean;
}

// 1. Создаем экземпляр с настройками
const axiosInstance: AxiosInstance = axiosOriginal.create({
  baseURL: '/pgrst', //import.meta.env.VITE_BASEURL,
  headers: {
    'Content-Type': 'application/json',
    // 'Cache-Control': 'no-cache',  // ←
    // 'Pragma': 'no-cache',         // ←
  },
});

// 2. Интерцептор запросов
axiosInstance.interceptors.request.use((config) => {
  // if (config.method === 'get') {
  //   config.headers['Cache-Control'] = 'no-cache, no-store';
  //   config.headers['Pragma'] = 'no-cache';
  // }
  const state = useAuthStore.getState();
  const token = state.accessToken;
  console.log('[Interceptor] authState:', state.authState, 'token:', token ? 'exists' : 'null');
  console.log('[Interceptor] Token from store:', token?.substring(1,20)+'...');
  console.log('[Interceptor] config.headers:', config.headers);
  console.log('[Request] URL:', config.url);
  console.log('[Request] Token in Store:', token?.substring(1,20)+'...');

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  // } else if (config.headers) {
  //   // ← После логаута чистим заголовок, если токена нет
  //   delete config.headers.Authorization;
  //   console.log('[Interceptor] config.headers.Authorization deleted');
  }

  return config;
});

// 3. Интерцептор ответов (Refresh Token логика)
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config as CustomRequestConfig;

    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        // Используем fetch-логику из твоего стора (apiRequest)
        await useAuthStore.getState().refresh();
        const newToken = useAuthStore.getState().accessToken;

        if (newToken) {
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          // Важно: вызываем повторный запрос именно через наш экземпляр
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        useAuthStore.getState().logout();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// 4. Экспортируем экземпляр под именем axios
const axios = axiosInstance;
export default axios;